import axios from 'axios';

const ROOT = 'api/v1/studies';

const EncounterLogCheckApi = {
  getLogCheckAnswers(studyId, sitePatientId, encounterId, itemGroupTemplateId, itemGroupTemplateVersionId) {
    return axios.get(
      `${ROOT}/${studyId}/patients/${sitePatientId}/encounters/${encounterId}/item-group-templates/${itemGroupTemplateId}/versions/${itemGroupTemplateVersionId}/log-check/answers`
    );
  }
};

export default EncounterLogCheckApi;
